module.exports = __webpack_public_path__ + "static/media/29BDOS22.e2821ac0.jpg";